export default __webpack_public_path__ + "static/media/right_bg_arrow_down.1310f9b0.png";